import { useRef } from "react";
import { useSelector } from "react-redux";
import { Button, Empty, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import EventCard from "../Events/EventCard";
import {
  selectFeaturedEvents,
  selectFetchFeaturedEventsStatus,
  selectFetchFeaturedEventsError,
} from "../../redux/eventSlice";

export default function FeaturedEventsSection() {
  const sliderRef = useRef(null);
  const featuredEvents = useSelector(selectFeaturedEvents);
  const loading = useSelector(selectFetchFeaturedEventsStatus);
  const error = useSelector(selectFetchFeaturedEventsError);

  const displayEvents = (featuredEvents || []).slice(0, 9);

  const handleScroll = (direction) => {
    if (!sliderRef.current) return;
    const scrollDistance = 360;
    sliderRef.current.scrollBy({
      left: direction === "left" ? -scrollDistance : scrollDistance,
      behavior: "smooth",
    });
  };

  return (
    <section className="homeV2Section">
      <div className="container">
        <div className="homeV2SectionHeader">
          <h2 className="homeV2SectionTitle">Featured Events</h2>
          <div className="homeV2NavArrows">
            <Button aria-label="Scroll featured events left" icon={<LeftOutlined />} onClick={() => handleScroll("left")} />
            <Button aria-label="Scroll featured events right" icon={<RightOutlined />} onClick={() => handleScroll("right")} />
          </div>
        </div>
        <Spin spinning={loading === "loading"} tip="Loading featured events...">
          {!error && displayEvents.length > 0 ? (
            <div className="featuredEventsRow" ref={sliderRef}>
              {displayEvents.map((event) => (
                <div className="featuredEventsItem" key={event.id}>
                  <EventCard event={event} layout="featured" />
                </div>
              ))}
            </div>
          ) : (
            <Empty description="No featured events found" />
          )}
        </Spin>
      </div>
    </section>
  );
}
